import { Box } from "@mui/system";
import CACChartWrap from "./CACContent/CACChartWrap";
import { useSelector } from "react-redux";
import GraphSkeletonForTrendsMob from "../../../helpers/components/GraphSkeletonForTrendsMob";

const CAC = () => {
  const { loadingTrendsMobData } = useSelector((state: any) => state.trends);
  return (
    <>
      <Box sx={{ px: 2 }}>
        {loadingTrendsMobData ? (
          Array.from({ length: 2 }).map((_, index) => (
            <GraphSkeletonForTrendsMob key={index} />
          ))
        ) : (
          <CACChartWrap />
        )}
      </Box>
    </>
  );
};

export default CAC;
